import React from 'react';
import { PropTypes } from 'prop-types';
import { Button, Radios, Spacer, Textarea } from '@ontruck/orc';
import LoadSpinner from 'components/LoadSpinner';

class CancelForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      reason: false,
      comment: '',
      fetching: false,
      hasCommentError: false,
    };

    this.fetchCancel = this.fetchCancel.bind(this);
    this.handleComment = this.handleComment.bind(this);
    this.handleReason = this.handleReason.bind(this);
  }

  fetchCancel = async () => {
    const { reason, comment } = this.state;
    const { order, cancelOrder } = this.props;
    const isCommentEmpty =
      typeof comment !== 'string' ||
      comment.length === 0 ||
      comment.trim() === '';
    if (reason === 'REASON_OTHER' && isCommentEmpty) {
      this.setState({ hasCommentError: true });
      return;
    }

    this.setState({ fetching: true });

    cancelOrder({
      order,
      reason,
      comment: reason === 'REASON_OTHER' ? comment : '',
    });
  };

  handleComment = (_, { value }) => {
    this.setState({ comment: value, hasCommentError: false });
  };

  handleReason = (_, { value }) => {
    this.setState({ reason: value, hasCommentError: false });
  };

  render() {
    const { className, t } = this.props;
    const { reason, fetching, hasCommentError } = this.state;
    return (
      <div className={`${className}`} data-testid="modal-cancel-form">
        <Radios
          girded
          size="M"
          legend={t('cancel.subTitle')}
          name="cancellation-reasons"
          items={[
            {
              value: 'SO_I_DONT_NEED_IT_OR_CANT_DO_IT',
              label: t('cancel.reasons.SO_I_DONT_NEED_IT_OR_CANT_DO_IT'),
            },
            {
              value: 'SO_TOO_LONG_ASSIGNATION',
              label: t('cancel.reasons.SO_TOO_LONG_ASSIGNATION'),
            },
            { value: 'REASON_OTHER', label: t('cancel.reasons.REASON_OTHER') },
          ]}
          onChange={this.handleReason}
        />
        {reason === 'REASON_OTHER' && (
          <div
            className={
              hasCommentError
                ? 'commentContainer hasCommentError'
                : 'commentContainer'
            }
          >
            <Textarea
              onChange={this.handleComment}
              labelType="hidden"
              placeholder={t('cancel.reasons.reason_comment')}
              height="100px"
              width="100%"
              fullWidth
            />
            {hasCommentError && (
              <p>* {t('cancel.reasons.reason_comment_mandatory')}</p>
            )}
          </div>
        )}

        {fetching ? (
          <Spacer pTop="L" pBottom="L">
            <LoadSpinner />
          </Spacer>
        ) : (
          <Button
            data-e2e="submitCancelButton"
            disabled={!reason}
            skin="cancel"
            text={t('cancel.btn')}
            onClick={this.fetchCancel}
          />
        )}
      </div>
    );
  }
}

CancelForm.propTypes = {
  className: PropTypes.string,

  // onClose: PropTypes.func,
  cancelOrder: PropTypes.func,
  order: PropTypes.shape({ id: PropTypes.number }),
  t: PropTypes.func,
};

CancelForm.defaultProps = {
  className: '',
  order: {},
  // onClose:
  cancelOrder: () => ({}),
  t: (t) => t,
};

export default CancelForm;
